<template >
  <div class="container-flight margin_container_hf">
    <div class="search-box">
      <hotel-search :hotelList="hotelList" :cityList="cityList" />
    </div>

    <div class="row">
      <aside class="col-lg-3">
        <div id="filters_col">
          <a
            data-toggle="collapse"
            aria-expanded="false"
            aria-controls="collapseFilters"
            id="filters_col_bt"
            ><i class="icon_set_1_icon-65"></i
            >{{ $t("SearchResults.Filters") }}</a
          >
          <div class="collapse show" id="collapseFilters">
            <div class="filter_type">
              <h3>
                <i class="icon-money-2 filter-icon"></i> {{ $t("Price") }}
              </h3>
              <vue-slider
                v-model="priceFilter"
                :min="0"
                :max="200000000"
                :interval="100"
                @drag-end="filterBy()"
                :use-keyboard="false"
                :process="true"
                :enable-cross="false"
                :tooltip="'always'"
                :tooltip-formatter="formatterPrice"
                :process-style="{ backgroundColor: '#00c3e1' }"
                :tooltip-style="{
                  backgroundColor: '#00c3e1',
                  fontSize: '12px',
                  borderColor: '#00c3e1',
                }"
              >
                <template v-slot:dot="{ value, focus }">
                  <div :class="['custom-dot', { focus }]"></div>
                </template>
              </vue-slider>
            </div>
            <div class="filter_type">
              <h6>
                <i class="icon_set_1_icon-81 filter-icon"></i>
                {{ $t("SearchResults.Stars") }}
              </h6>

              <ul>
                <li v-for="star in starList">
                  <label style="cursor: pointer">
                    <div class="icheckbox_square-grey">
                      <input
                        type="checkbox"
                        class="checkBox"
                        v-model="checkedStars"
                        @change="filterBy()"
                        :value="star"
                      />
                    </div>
                    <span class="rating">
                      <i class="icon_set_1_icon-81" v-for="i in star"></i>
                      <i class="icon_set_1_icon-81" v-for="i in 5 - star"></i
                    ></span>
                  </label>
                </li>
              </ul>
            </div>

            <div class="filter_type">
              <h6>
                <i class="icon-home-4 filter-icon"></i>
                {{ $t("SearchResults.AccommodationType") }}
              </h6>
              <ul>
                <li v-for="(type, key) in hotelTypes">
                  <label style="cursor: pointer">
                    <div class="icheckbox_square-grey">
                      <input
                        type="checkbox"
                        class="checkBox"
                        v-model="checkedHotelTypes"
                        :value="type.id"
                      />
                    </div>
                    <span class="">{{ type.title }}</span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="filter_type">
              <h6>
                <i class="icon_set_1_icon-25 filter-icon"></i>
                {{ $t("SearchResults.Possibilities") }}
              </h6>
              <ul>
                <li v-for="(facility, key) in facilityList">
                  <label style="cursor: pointer">
                    <div class="icheckbox_square-grey">
                      <input
                        type="checkbox"
                        class="checkBox"
                        v-model="checkedFacility"
                        :value="facility.id"
                      />
                    </div>
                    <span class="">{{ facility.title }}</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <!--End collapse -->
        </div>
        <!--End filters col-->
        <div class="box_style_2" style="text-align: center">
          <i class="icon_set_1_icon-57" style="color: rgb(213, 171, 61)"></i>
          <h4>{{ $t("SearchResults.Support") }}</h4>
          <a
            href="tel://0098214411364"
            class="phone"
            style="color: rgb(225, 77, 103); direction: initial"
            >021-44631360-5
          </a>
          <a
            href="tel://0098214411364"
            class="phone"
            style="color: #e14d67; direction: initial"
            >09045425792
          </a>
        </div>
      </aside>
      <!--End aside -->
      <div class="col-lg-9">
        <div id="tools">
          <div class="row">
            <div class="container-fluid">
              <div id="hotelList" class="row">
                <div class="tabbable-panel">
                  <div class="tabbable-line">
                    <ul class="nav nav-tabs">
                      <i
                        class="icon-sort"
                        aria-hidden="true"
                        style="
                          margin: 5px 20px 0px 20px;
                          font-size: 25px;
                          color: #084a6a;
                        "
                      ></i>

                      <li
                        @click="(tabIndex = 0), orderBy('hotel_MinPrice')"
                        :class="{ active: tabIndex == 0 }"
                      >
                        <div data-toggle="tab">
                          {{ $t("SearchResults.LowestPrice") }}
                        </div>
                      </li>
                      <li
                        @click="(tabIndex = 1), orderBy('hotel_MinPrice desc')"
                        :class="{ active: tabIndex == 1 }"
                      >
                        <div data-toggle="tab">
                          {{ $t("SearchResults.HighestPrice") }}
                        </div>
                      </li>
                      <li
                        @click="(tabIndex = 3), orderBy('hotel_Rank')"
                        :class="{ active: tabIndex == 3 }"
                      >
                        <div data-toggle="tab">
                          {{ $t("SearchResults.LowestPoint") }}
                        </div>
                      </li>
                      <li
                        @click="(tabIndex = 2), orderBy('hotel_Rank desc')"
                        :class="{ active: tabIndex == 2 }"
                      >
                        <div data-toggle="tab">
                          {{ $t("SearchResults.HighestPoint") }}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/tools -->

        <HotelResultSkeleton v-if="!isLoadData" />
        <div v-else>
          <div v-if="hotelListResult.length > 0">
            <div
              v-for="(hotel, index) in hotelListResult"
              :key="index"
              class="strip_all_tour_list wow fadeIn"
              data-wow-delay="0.4s"
              style="
                visibility: visible;
                animation-delay: 0.4s;
                animation-name: fadeIn;
              "
            >
              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <div class="img_list">
                    <a>
                      <img
                        class="hotel_image"
                        :src="hotel.thumbnailUrl"
                        alt="Image"
                      />
                      <!-- <div class="short_info">
                    <i class="icon_set_1_icon-37"></i>Walking tour
                  </div> -->
                    </a>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div
                    class="tour_list_desc"
                    style="display: inline-block; height: auto"
                  >
                    <div class="rating">
                      <i
                        data-v-1bbc1f64=""
                        aria-hidden="true"
                        class="fa fa-star list-star"
                        v-for="star in parseInt(hotel.hotelStar)"
                      ></i>
                      <i
                        data-v-1bbc1f64=""
                        aria-hidden="true"
                        class="icon-star-empty"
                        v-for="star in parseInt(5 - hotel.hotelStar)"
                      ></i>

                      <div class="score" style="float: left">
                        <span>{{ hotel.hotel_Rank }}</span>
                      </div>
                      <small></small>
                    </div>
                    <h3><strong> </strong> {{ hotel.name }}</h3>
                    <div v-if="!isShowMore">
                      <p v-if="hotel.generalInfo.length <= 180">
                        {{ hotel.generalInfo }}
                      </p>
                      <p v-else="hotel.generalInfo.length">
                        {{ hotel.generalInfo.substring(0, 180) }}
                        <span
                          class="read-more"
                          @click="isShowMore = !isShowMore"
                          >{{ $t("SearchResults.More") }}</span
                        >
                      </p>
                    </div>
                    <div v-if="isShowMore">
                      <p>
                        {{ hotel.generalInfo }}
                        <span
                          class="read-more"
                          @click="isShowMore = !isShowMore"
                          >{{ $t("SearchResults.Fewer") }}</span
                        >
                      </p>
                    </div>
                    <ul class="add_info">
                      <li v-if="hotel.parking">
                        <div class="tooltip_styled tooltip-effect-4">
                          <span class="tooltip-item"
                            ><i class="icon_set_1_icon-781"></i
                          ></span>
                          <div class="tooltip-content">
                            {{ $t("SearchResults.Possibility4") }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="price_list">
                    <div>
                      <p>
                        <span> {{ $t("SearchResults.From") }}</span>
                        {{ hotel.minPrice | numFormat }}

                        <span> {{ $t("SearchResults.To") }}</span>
                      </p>
                      <p>
                        <a
                          ref="refId"
                          @click="selectRooms(hotel.hotelId)"
                          class="btn_1"
                          style="color: #fff"
                        >
                          {{ $t("SearchResults.ChooseRoom") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--End strip -->

            <hr />
            <div
              class="d-flex align-items-center justify-content-center"
              v-if="hotelListResult.length"
            >
              <paginate
                v-model="pageNumber"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="getHotelsByPaging"
                :active-class="'paginate-active'"
                :prev-text="'«'"
                :next-text="'»'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :next-class="'next-class'"
                :next-link-class="'next-link-class'"
                :prev-class="'prev-class'"
                :prev-link-class="'prev-class-link'"
              >
              </paginate>

              <!-- end pagination-->
            </div>
          </div>
          <div v-else>
            <HotelNotFound
              @notFoundAction="onHotelNotFound($event)"
              :withoutChangeDate="true"
            >
              <div style="text-align: center" slot="message">
                <img
                  id="timer-logo"
                  width="150"
                  height="150"
                  src="../../../public/img/vector-hotel.png"
                />

                <h4 style="margin-top: 10px">
                  {{ $t("SearchResults.SorryFreeHotel") }}
                  <span>{{ $t("SearchResults.NotFound") }}.</span>
                </h4>
              </div>
            </HotelNotFound>
          </div>
        </div>
      </div>
      <!-- End col lg-9 -->
    </div>
    <!-- End row -->
  </div>
</template>

<script>
import hotelSearch from "../../components/hotel/HotelSearch";
import Store from "../../views/hotel/store/index";
import HotelResultSkeleton from "../../components/hotel/HotelResultSkeleton";
import VueSlider from "vue-slider-component";
import loadingBar from "../../components/PdkLoading.vue";
import "vue-slider-component/theme/default.css";

import HotelNotFound from "../../components/tour/HotelNotFound";
var qs = require("qs");

export default {
  name: "HotelSearch",
  components: {
    hotelSearch,
    loadingBar,
    VueSlider,
    HotelResultSkeleton,
    HotelNotFound,
  },
  store: Store,

  data() {
    return {
      params: {},
      localee: "fa",
      hotelList: [],
      hotelListResult: [],
      cityList: [],
      facilityList: [
        { id: 3, title: "اینترنت رایگان" },
        { id: 4, title: "پارکینگ" },
        { id: 9, title: "خدمات گردشگری" },
        {
          id: 15,
          title: "کافی شاپ",
        },
        {
          id: 16,
          title: "تاکسی سرویس",
        },
      ],
      hotelTypes: [
        {
          id: 11,
          title: "Hotel",
        },

        {
          id: 17,
          title: "Hotel Apartment",
        },
      ],
      checkedFacility: [],
      checkedHotelTypes: [],
      starList: [],
      checkedStars: [],
      priceValue: [],
      priceFilter: [0, 2000000000],
      priceData: [],
      minPriceFilter: 0,
      maxPriceFilter: 0,
      formatterPrice: (v) =>
        `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      tabIndex: 0,
      request: {},
      isLoadData: false,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      userName: "tour.pdk",
      password: "123456",
      isShowMore: false,
    };
  },

  computed: {
    priceFilterList() {
      let arr = [];
      if (this.hotelListResult.length != 0) {
        let minPrice = this.hotelListResult
          .filter((p) => p.hotel_Id)
          .select((p) => p.hotel_MinPrice);
        minPrice = Math.max.apply(Math, minPrice);

        this.minPriceFilter = 0;
        this.maxPriceFilter = minPrice;

        for (let i = 0; i <= minPrice; i = i + 100) {
          arr.push(i);
        }

        if (this.params.fromPrice) this.minPriceFilter = this.params.fromPrice;
        if (this.params.toPrice) this.maxPriceFilter = this.params.toPrice;

        this.priceFilter = [
          parseInt(this.minPriceFilter),
          parseInt(this.maxPriceFilter),
        ];
        var locale = this.localee;
        this.hotelListResult.map((x) => {
          (x.name = this.$i18n.messages[locale].HotelsList["name" + x.hotelId]),
            (x.address =
              this.$i18n.messages[locale].HotelsList["address" + x.hotelId]),
            (x.city =
              this.$i18n.messages[locale].HotelsList["city" + x.hotelId]),
            (x.generalInfo =
              this.$i18n.messages[locale].HotelsList[
                "generalInfo" + x.hotelId
              ]),
            (x.propertyType =
              this.$i18n.messages[locale].HotelsList[
                "propertyType" + x.hotelId
              ]),
            (x.propertyType =
              this.$i18n.messages[locale].HotelsList[
                "propertyType" + x.hotelId
              ]),
            (x.locationInfo =
              this.$i18n.messages[locale].HotelsList[
                "locationInfo" + x.hotelId
              ]);
        });
        return arr;
      }
    },
    getAdaults() {
      const params = this.$route.query;
      return JSON.parse(params.rooms).sum((t) => t.adults);
    },
    getChildren() {
      const params = this.$route.query;
      var rooms = JSON.parse(params.rooms);
      var totalChild = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age >= 2) {
            totalChild = totalChild + 1;
          }
        });
      });
      return totalChild;
    },
    getInfants() {
      const params = this.$route.query;
      var rooms = JSON.parse(params.rooms);
      var totalInfant = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age < 2) {
            totalInfant = totalInfant + 1;
          }
        });
      });
      return totalInfant;
    },
  },
  async created() {
    // console.log('url Config Lists',this.$config);
    this.params = this.$route.query;
    this.pageNumber = parseInt(this.params.pageNumber);
    this.$nextTick(() => {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    });
    this.createStartList();
    this.createRequest();
    this.getHotelList();
    this.getLocationList();
  },
  mounted() {
    const julie = document.getElementById("hotelList");

    // julie.scrollIntoView(true);
    julie.scrollIntoView({
      block: "center",
    });
  },

  methods: {
    onHotelNotFound() {
      this.$router.push({
        path: "/",
      });
    },
    createRequest() {
      this.request = {
        city: this.params.city,
        startDate: this.params.startDate,
        endDate: this.params.endDate,
        numberOfAdults: this.params.numberOfAdults,
        numberOfChildren: this.params.numberOfChildren,
        numberOfRoom: this.params.numberOfRoom,
        sourceId: localStorage.getItem("SourceIdInReport"),
        sourceProfileId: localStorage.getItem("SourceProfileId"),
      };

      this.setFilterFromRouth();
    },
    setFilterFromRouth() {
      this.localee = this.$i18n.locale;
      var locale = this.localee;
      this.hotelTypes.map((x) => {
        x.title = this.$i18n.messages[locale].SearchResults["Accomm" + x.id];
        console.log(x);
      });
      this.facilityList.map((x) => {
        x.title =
          this.$i18n.messages[locale].SearchResults["Possibility" + x.id];
        console.log(x);
      });

      if (this.params.fromPrice) {
        this.request = Object.assign(
          { fromPrice: this.params.fromPrice },
          this.request
        );
        this.minPriceFilter = this.params.fromPrice;
      }

      if (this.params.toPrice) {
        this.request = Object.assign(
          { toPrice: this.params.toPrice },
          this.request
        );
        this.maxPriceFilter = this.params.toPrice;
      }

      this.priceFilter = [
        parseInt(this.minPriceFilter),
        parseInt(this.maxPriceFilter),
      ];
      if (this.params.stars) {
        this.request = Object.assign(
          { stars: this.params.stars },
          this.request
        );
        let checkedStars = this.params.stars.split(",");
        this.checkedStars = checkedStars;
      }
      if (this.params.hotelTypes) {
        this.request = Object.assign(
          { hotelTypes: this.params.hotelTypes },
          this.request
        );
        let checkedHotelTypes = this.params.hotelTypes.split(",");
        this.checkedHotelTypes = checkedHotelTypes;
      }
      if (this.params.facility) {
        this.request = Object.assign(
          { facility: this.params.facility },
          this.request
        );
        let checkedFacility = this.params.facility.split(",");
        this.checkedFacility = checkedFacility;
      }
      if (this.params.sortBy == "hotel_MinPrice") this.tabIndex = 0;
      else if (this.params.sortBy == "hotel_MinPrice desc") this.tabIndex = 1;
      else if (this.params.sortBy == "hotel_Rank desc") this.tabIndex = 2;
      else if (this.params.sortBy == "hotel_Rank") this.tabIndex = 3;

      this.getHotelSearchResult();
    },
    getHotelSearchResult() {
      this.isLoadData = false;
      this.$store
        .dispatch("getHotelListCrs", qs.stringify(this.request))
        .then((res) => {
          this.hotelListResult = res.data.hotels;
          this.isLoadData = true;
          var locale = "fa";
          this.hotelListResult.map((x) => {
           
            (x.name =
              this.$i18n.messages[locale].HotelsList["name" + x.hotelId]),
              (x.address =
                this.$i18n.messages[locale].HotelsList["address" + x.hotelId]),
              (x.city =
                this.$i18n.messages[locale].HotelsList["city" + x.hotelId]),
              (x.generalInfo =
                this.$i18n.messages[locale].HotelsList[
                  "generalInfo" + x.hotelId
                ]),
              (x.propertyType =
                this.$i18n.messages[locale].HotelsList[
                  "propertyType" + x.hotelId
                ]),
              (x.propertyType =
                this.$i18n.messages[locale].HotelsList[
                  "propertyType" + x.hotelId
                ]),
              (x.locationInfo =
                this.$i18n.messages[locale].HotelsList[
                  "locationInfo" + x.hotelId
                ]);
          });
          console.log(this.hotelListResult, 'general info created');
        });
    },
    getHotelsByPaging() {
      delete this.request.pageNumber;
      this.request = Object.assign(
        { pageNumber: this.pageNumber },
        this.request
      );

      this.$router
        .push({
          name: "hotelresult",
          query: this.request,
        })
        .catch(() => {});
    },

    getHotelType() {
      const request = {
        pageNumber: 1,
        pageSize: 300,
        needTotalCount: true,
        sortAscending: true,
      };

      this.$store
        .dispatch("getAllHotelTypes", qs.stringify(request))
        .then((res) => {
          this.hotelTypes = res.hotelTypeList;
        });
    },

    getFacility() {
      const request = {
        definitionLevel: 0,
        pageNumber: 1,
        pageSize: 300,
        needTotalCount: true,
        sortAscending: true,
      };

      this.$store
        .dispatch("getFacilityList", qs.stringify(request))
        .then((res) => {
          this.facilityList = res.facilityList;
        });
    },
    async getLocationList() {
      this.cityList = await this.$store.dispatch("getLocations");
      this.cityList = this.cityList.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );
    },
    async getHotelList() {
      const hotelList = await this.$store.dispatch("getHotelList");
      if (Array.isArray(hotelList)) {
        this.mapHotelData(hotelList);
      }
    },
    mapHotelItem(item) {
      const data = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "Hotel",
      };

      return data;
    },
    mapHotelData(hotelList) {
      hotelList.forEach((element) => {
        const data = this.mapHotelItem(element);

        this.hotelList.push(data);
      });
    },
    getSearchItems() {
      var rooms = JSON.parse(this.params.rooms);
      var pax = 0;
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);
      rooms.forEach((element) => {
        pax =
          pax +
          (Number(element.infants) + Number(element.children),
          Number(element.adults));
      });
      this.searchItems = {
        origin: rooms.originName,
        destination: this.params.destinationName,
        fromDate: fromDate,
        toDate: toDate,
        pax: pax,
        rooms: rooms,
        roomsCount: rooms.length,
      };
    },

    createStartList() {
      for (let i = 1; i <= 5; i++) {
        this.starList.push(i);
      }
      this.starList = this.starList.reverse();
    },

    filterBy() {
      let minPrice = this.priceFilter[0];
      let maxPrice = this.priceFilter[1];

      delete this.request.fromPrice;
      this.request = Object.assign({ fromPrice: minPrice }, this.request);

      delete this.request.toPrice;
      this.request = Object.assign({ toPrice: maxPrice }, this.request);

      /// filter star
      if (this.checkedStars.length) {
        delete this.request.stars;
        let stars = "";
        this.checkedStars.forEach((element) => {
          stars += element + ",";
        });
        this.request = Object.assign(
          { stars: stars.substring(0, stars.length - 1) },
          this.request
        );
      } else {
        delete this.request.stars;
      }
      /// filter hotelType
      if (this.checkedHotelTypes.length) {
        delete this.request.hotelTypes;

        let hotelTypes = "";
        this.checkedHotelTypes.forEach((element) => {
          hotelTypes += element + ",";
        });
        this.request = Object.assign(
          { hotelTypes: hotelTypes.substring(0, hotelTypes.length - 1) },
          this.request
        );
      } else {
        delete this.request.hotelTypes;
      }

      /// filter facility
      if (this.checkedFacility.length) {
        delete this.request.facility;

        let fac = "";
        this.checkedFacility.forEach((element) => {
          fac += element + ",";
        });
        this.request = Object.assign(
          { facility: fac.substring(0, fac.length - 1) },
          this.request
        );
      } else {
        delete this.request.facility;
      }

      delete this.request.pageNumber;
      this.pageNumber = 1;
      this.request = Object.assign({ pageNumber: 1 }, this.request);

      this.getHotelsByPaging();
    },
    orderBy(sortBy) {
      // delete this.request.pageNumber;
      // this.pageNumber = 1;
      // delete this.request.sortBy;
      // this.request = Object.assign({ sortBy: sortBy }, this.request);
      // this.getHotelsByPaging();
    },
    selectRooms(hotelId) {
      const request = {
        hotelId: hotelId,
        startDate: this.params.startDate,
        endDate: this.params.endDate,
        city: this.params.city,
        rooms: this.params.rooms,
      };

      this.$router
        .push({
          name: "hotelrooms",
          query: request,
        })
        .catch(() => {});
    },
  },
};
</script>


<style   scoped >
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.margin_60 {
  padding-top: 120px;
  padding-bottom: 60px;
}

.search-box {
  position: relative;
  z-index: 9999;
  padding-bottom: 40px;
}

ul#cat_nav li a {
  position: relative;
  color: #777;
}

ul#cat_nav li a:after {
  font-family: fontello;
  content: "";
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 13px !important;
}

.selected-item {
  background: #d5ac40;
  color: #fff;
  font-size: 13px;
  text-align: center;
  padding: 2px;
  border-radius: 3px;
}

.list-star {
  color: #fbd717;
  font-size: 16px;
  padding-right: 5px;
}

.hotel-star {
  color: #fbd717;
  font-size: 20px;
  padding-right: 5px;
}

.star-size {
  font-size: 20px;
}

.v-top::after {
  right: -17px;
  top: 6px;
  border-width: 9px;
  border-color: transparent transparent transparent #f95379;
  border-style: solid;
}

.top::after {
  right: -17px;
  top: 6px;
  border-width: 9px;
  border-color: transparent transparent transparent #00c3e1;
  border-style: solid;
}

.custom-dot {
  width: 120%;
  height: 120%;
  /* border-radius: 10px; */
  background-color: #00c3e1;
  transition: all 0.3s;
}

.custom-dot:hover {
  cursor: pointer;
  transform: rotateZ(45deg);
}

.custom-dot.focus {
  border-radius: 50%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.price_list p {
  font-size: 18px !important;
  margin-bottom: 15px;
  font-weight: bold;
}

.price_list span {
  font-size: 12px !important;
}

.tooltip_styled {
  display: inline;
  position: relative;
  z-index: 999;
}

ul.add_info {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul.add_info li {
  display: inline-block;
  margin-right: 5px;
  border: 1px solid #ededed;
  /* text-align: center; */
  width: 35px;
  height: 35px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.tooltip_styled {
  display: inline;
  position: relative;
  z-index: 999;
}

.tooltip-item {
  cursor: pointer;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  z-index: 9999 !important;
  width: 100px;
  left: 50%;
  margin: 0 0 20px -50px;
  bottom: 100%;
  text-align: center;
  line-height: 5px;
  display: block;
  padding: 15px;
  font-size: 10px;
  color: #fff;
  box-shadow: -5px -5px 15px rgb(48 54 61 / 20%) !important;
  background: #00c3e1 !important;
  border-radius: 20px;
  cursor: default;
  pointer-events: none;
  direction: rtl;
}

.tooltip-content::after {
  content: "";
  top: 100%;
  left: 50%;
  border: solid transparent;
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: transparent;
  border-top-color: #00c3e1;
  border-width: 10px;
  margin-left: -10px;
}

.tooltip-content h4 {
  display: block;
  margin: 0 0 10px 0;
  line-height: 14px;
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
}

.tooltip-item::after {
  content: "";
  position: absolute;
  width: 300px;
  height: 20px;
  bottom: 100%;
  left: 50%;
  pointer-events: none;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

b,
strong {
  font-weight: bolder;
}

input[type="checkbox"] {
  width: 22px;
  /*Desired width*/
  height: 22px;
  /*Desired height*/
}

#tools {
  background-color: #fff;
  -webkit-box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15;
  padding: 5px;
  margin-bottom: 25px;
}

.filter_type h3 {
  border-top: 1px solid #e8eced;
  margin: 20px 0;
  padding: 15px 0 0 0;
  font-size: 16px;
  margin-bottom: 40px !important;
  color: #08446a;
}

.filter_type h6 {
  border-top: 1px solid #e8eced;
  margin: 20px 0;
  padding: 15px 0 0 0;
  font-size: 14px;
  margin-bottom: 40px !important;
  color: #08446a;
}

.tabbable-panel {
  /* border: 1px solid #eee; */
  padding: 5px;
  cursor: pointer;
}

.tabbable-line > .nav-tabs {
  border: none;
  margin: 0px;
}

.tabbable-line > .nav-tabs > li {
  margin-right: 2px;
}

.tabbable-line > .nav-tabs > li > div {
  border: 0;
  margin-right: 0;
  font-weight: 300;
  letter-spacing: -0.5px;
  font-size: 17px;
}

.tabbable-line > .nav-tabs > li > div > i {
  color: #1d1d1d;
}

.tabbable-line > .nav-tabs > li.open,
.tabbable-line > .nav-tabs > li:hover {
  border-bottom: 4px solid #32465b;
}

.tabbable-line > .nav-tabs > li.open > a,
.tabbable-line > .nav-tabs > li:hover > a {
  border: 0;
  background: none !important;
  color: #333333;
}

.tabbable-line > .nav-tabs > li.open > a > i,
.tabbable-line > .nav-tabs > li:hover > a > i {
  color: #a6a6a6;
}

.tabbable-line > .nav-tabs > li.open .dropdown-menu,
.tabbable-line > .nav-tabs > li:hover .dropdown-menu {
  margin-top: 0px;
}

.tabbable-line > .nav-tabs > li.active {
  border-bottom: 4px solid #00c3e1;
  position: relative;
}

.tabbable-line > .nav-tabs > li.active > div {
  border: 0;
  color: #333333;
}

.tabbable-line > .nav-tabs > li.active > div > i {
  color: #404040;
}

.tabbable-line > .tab-content {
  margin-top: -3px;
  background-color: #fff;
  border: 0;
  border-top: 1px solid #eee;
  padding: 15px 0;
}

.portlet .tabbable-line > .tab-content {
  padding-bottom: 0;
}

.nav > li > div {
  position: relative;
  display: block;
  padding: 5px 25px;
}

.rating i {
  color: #fcbe2f;
}

.rank {
  float: left;
  background-color: #08446a;
  padding: 6px;
  border-radius: 6px 3px 6px 3px;
  font-size: 14px;
  color: white;
  cursor: default;
}

a {
  color: #333;
}

.score span {
  border: 2px solid #00c3e1;
  color: #00c3e1;
}

.read-more {
  color: #198cfb;
  font-weight: bold;
}
</style>

<style >
a {
  color: #333;
}

.icon_set_1_icon-781:before {
  content: "\3b" !important;
}

.icon_set_2_icon-116:before {
  content: "󨃣";
}

.hotel_image {
  /* width: 290px !important; */
  height: 198px !important;
  margin-top: 8px !important;
}
</style>
